export type Digit = number // 0-9

const validateDigits = (digits: Digit[]) => {
  if (!Array.isArray(digits) || digits.length < 3) {
    throw new Error('กรุณาเลือกตัวเลขอย่างน้อย 3 ตัวขึ้นไป')
  }
  for (const d of digits) {
    if (!Number.isInteger(d) || d < 0 || d > 9) {
      throw new Error('ตัวเลขต้องเป็น 0-9 เท่านั้น')
    }
  }
}

/**
 * 1) จับวิน 2 ตัว "ไม่รวมเลขเบิ้ล"
 * - ยึดลำดับ input (ไม่ sort)
 * - ทุกคู่ (i,j) ที่ i !== j และ digit ไม่ซ้ำ (ไม่เอา dd)
 * - ตรงกับของเก่า: แต่ละตัวจับคู่กับทุกตัวที่เหลือ → ได้ 24, 32, 42, 43, 23, 34
 */
export function genWin2KeepOrderNoDouble(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []

  for (let i = 0; i < digits.length; i++) {
    for (let j = 0; j < digits.length; j++) {
      if (i === j) continue
      const a = digits[i]
      const b = digits[j]
      if (a === b) continue // ไม่เอาเบิ้ล
      out.push(`${a}${b}`)
    }
  }

  return out
}

/**
 * 2) จับวิน 2 ตัว "รวมเลขเบิ้ล"
 * - ยึดลำดับ input (ไม่ sort)
 * - ทุกคู่ (i,j) ที่ i !== j แล้วเพิ่ม dd ตามตัวที่เลือก
 */
export function genWin2KeepOrderIncludeDouble(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []

  for (let i = 0; i < digits.length; i++) {
    for (let j = 0; j < digits.length; j++) {
      if (i === j) continue
      out.push(`${digits[i]}${digits[j]}`)
    }
  }

  // เพิ่มเลขเบิ้ล dd ตามลำดับที่เลือก
  for (const d of digits) out.push(`${d}${d}`)

  return out
}

/** สร้างการเรียงสับเปลี่ยน (permutation) ของ [a,b,c] ทั้ง 6 แบบ */
function perm3(a: number, b: number, c: number): string[] {
  return [
    `${a}${b}${c}`,
    `${a}${c}${b}`,
    `${b}${a}${c}`,
    `${b}${c}${a}`,
    `${c}${a}${b}`,
    `${c}${b}${a}`,
  ]
}

/**
 * 3) จับวิน 3 ตัว "ไม่รวมเลขหามตอง"
 * - ยึดลำดับ input (ไม่ sort)
 * - ต้องเป็น ABC เท่านั้น (ห้ามมีเลขซ้ำ) → ทุกการเรียงสับเปลี่ยนของ 3 ตัวที่ต่างกัน
 * - ตรงกับของเก่า: numberNoHabTong ได้ 234, 243, 324, 342, 423, 432
 */
export function genWin3KeepOrderNoHamNoTong(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []

  for (let i = 0; i < digits.length; i++) {
    for (let j = i + 1; j < digits.length; j++) {
      for (let k = j + 1; k < digits.length; k++) {
        const a = digits[i],
          b = digits[j],
          c = digits[k]
        if (a === b || a === c || b === c) continue // ตัดหาม + ตอง
        out.push(...perm3(a, b, c))
      }
    }
  }

  return out
}

/**
 * 4) จับวิน 3 ตัว "รวมเลขหามตอง"
 * - ยึดลำดับ input (ไม่ sort)
 * - อนุญาต AAB / ABA / BAA / AAA ได้ → ทุกเลข 3 หลักที่แต่ละหลักมาจากชุดที่เลือก
 * - ตรงกับของเก่า: loop หลักที่ 3 ทุกตัว + เติมตอง 000-999 ตามที่เลือก
 */
export function genWin3KeepOrderIncludeHamTong(digits: Digit[]): string[] {
  validateDigits(digits)

  const out: string[] = []

  for (let i = 0; i < digits.length; i++) {
    for (let j = 0; j < digits.length; j++) {
      for (let k = 0; k < digits.length; k++) {
        out.push(`${digits[i]}${digits[j]}${digits[k]}`)
      }
    }
  }

  return out
}
